import { Configuration } from '@/types';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import { TreeViewConstants } from '@/types/constants/TreeViewConstants';

const ArenaSignEditDocumentTypes = () =>
  import(
    /* webpackChunkName: "DocusignEditDocumentTypes" */
    '@/views/configuration/arenaSign/ArenaSignEditDocumentTypes.vue'
  );

const meta = {
  layout: 'TreeView',
  treePath: 'docusigndocumenttypes',
  treeViewKey: TreeViewConstants.Keys.Configuration,
  title: 'DocuSign Document Types'
};

export const DocumentTypeRoutes = [
  {
    ...Configuration.DocuSign.DocumentType.Management,
    components: {
      default: ArenaSignEditDocumentTypes,
      treeView: ConfigurationTreeView
    },
    meta
  }
];
